// import React, { useCallback, useEffect, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { environment } from "../../environments/environments";
// import { chatConnectionFeeList } from "../api/api";
// import "./Monthly.css";
// import { cibSonos } from "@coreui/icons";

// const buildFeaturesFromApi = (apiPlan) => [
//   ["Profile Verification", true],
//   ["Temperament & Values Assessment", true],
//   ["AI Compatibility Matching", true],
//   ["Admin-Guided Connections", true],
//   ["Matches per Month", apiPlan.matches || "N/A"],
//   ["Chat Access After Match", true],
//   ["Connection Reports", apiPlan.counselling === "1" ? "Full" : "Basic"],
//   [
//     "Counselor Support",
//     apiPlan.counselling === "1" ? "Included" : "Not Included",
//   ],
//   ["Priority Matching", apiPlan.priority],
//   [
//     "Event Access",
//     apiPlan.event_access === "1"
//       ? "Limited"
//       : apiPlan.event_access === "2"
//       ? "Full"
//       : "Low",
//   ],
//   ["Cost", apiPlan.price ? "Variable" : "N/A"],
// ];

// const Monthly = () => {
//   const [loading, setLoading] = useState(false);
//   const [paymentDetails, setPaymentDetails] = useState([]);
//   const [latestPurchasedPlan, setLatestPurchasedPlan] = useState(null);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const counsellingvalue = location.state?.counsellingEnabled;
//   console.log("valuessssss-montly", counsellingvalue);

//   useEffect(() => {
//     const fetchPaymentDetails = async () => {
//       setLoading(true);
//       try {
//         const userData = localStorage.getItem("currentUser");
//         const parsedUserData = JSON.parse(userData);
//         const _id = parsedUserData?.id || parsedUserData?._id;

//         const values = {
//           user_id: _id,
//           counselling: counsellingvalue,
//           frequency: "month",
//         };

//         const response = await chatConnectionFeeList(values);
//         setPaymentDetails(response?.plans || []);
//         setLatestPurchasedPlan(response?.latestPurchasedPlan || null);
//       } catch (error) {
//         console.error("Error fetching plans:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPaymentDetails();
//   }, [counsellingvalue]);

//   const handlePlanPayment = (plan) => {
//     console.log("planssss", plan);
//     const userData = localStorage.getItem("currentUser");
//     const parsedUserData = JSON.parse(userData);
//     const _id = parsedUserData?.id || parsedUserData?._id;
//     const url = `https://backend.connecttovow.com/subscribe-to/${plan?.id}/${_id}`;
//     navigate("/ConnectionPaymentWebView", { state: { paymentUrl: url } });
//     // window.open(url, "_blank");
//   };

//   return (
//     <div className="monthly-container">
//       {loading ? (
//         <div className="loading-indicator">
//           <span className="loader" />
//         </div>
//       ) : paymentDetails.length === 0 ? (
//         <p className="no-plans">No plans available.</p>
//       ) : (
//         paymentDetails.map((apiPlan, idx) => {
//           const features = buildFeaturesFromApi(apiPlan);
//           const isCurrentPlanActive =
//             latestPurchasedPlan?.subscription_status === "active" &&
//             latestPurchasedPlan?.product_id === apiPlan.id;

//           return (
//             <div
//               key={idx}
//               className={`monthly-card ${
//                 isCurrentPlanActive ? "active-border" : ""
//               }`}
//             >
//               <h3 className="card-header">{apiPlan.name}</h3>

//               {features.map(([label, value], i) => (
//                 <div key={i} className="feature-row">
//                   <span className="feature-label">{label}</span>
//                   <span className="feature-value">
//                     {value === true
//                       ? "✔"
//                       : value === false
//                       ? "✖"
//                       : typeof value === "string"
//                       ? value.charAt(0).toUpperCase() + value.slice(1)
//                       : value}
//                   </span>
//                 </div>
//               ))}

//               <button
//                 className={`subscribe-button ${
//                   isCurrentPlanActive ? "disabled" : ""
//                 }`}
//                 onClick={() =>
//                   !isCurrentPlanActive && handlePlanPayment(apiPlan)
//                 }
//                 disabled={isCurrentPlanActive}
//               >
//                 {isCurrentPlanActive
//                   ? "Already Subscribed"
//                   : `Subscribe for ${apiPlan.currency_symbol}${apiPlan.price}/${
//                       apiPlan.frequency.charAt(0).toUpperCase() +
//                       apiPlan.frequency.slice(1)
//                     }`}
//               </button>
//             </div>
//           );
//         })
//       )}
//     </div>
//   );
// };

// export default Monthly;

import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { environment } from "../../environments/environments";
import {
  chatConnectionFeeList,
  getinfluencercode,
  GetStripeData,
  getUserById,
} from "../api/api";
import "./Monthly.css";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import MonthlyCheckoutForm from "./MonthlyCheckoutForm";
import Swal from "sweetalert2";

const stripePromise = loadStripe(environment?.stripe_id);

const buildFeaturesFromApi = (apiPlan) => [
  ["Profile Verification", true],
  ["Temperament & Values Assessment", true],
  ["AI Compatibility Matching", true],
  ["Admin-Guided Connections", true],
  ["Matches per Month", apiPlan.matches || "N/A"],
  ["Chat Access After Match", true],
  ["Connection Reports", apiPlan.counselling === "1" ? "Full" : "Basic"],
  [
    "Counselor Support",
    apiPlan.counselling === "1" ? "Included" : "Not Included",
  ],
  ["Priority Matching", apiPlan.priority],
  [
    "Event Access",
    apiPlan.event_access === "1"
      ? "Limited"
      : apiPlan.event_access === "2"
      ? "Full"
      : "Low",
  ],
  ["Cost", apiPlan.price ? "Variable" : "N/A"],
];

const Monthly = () => {
  const [loading, setLoading] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [latestPurchasedPlan, setLatestPurchasedPlan] = useState(null);
  const [clientSecret, setClientSecret] = useState("");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [uservalue, setUservalue] = useState(null);
  const [influencercode, setinfluencercode] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const counsellingvalue = location.state?.counsellingEnabled;
  const [showStripeModal, setShowStripeModal] = useState(false);

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      setLoading(true);
      try {
        const userData = localStorage.getItem("currentUser");
        const parsedUserData = JSON.parse(userData);
        const _id = parsedUserData?.id || parsedUserData?._id;

        const values = {
          user_id: _id,
          counselling: counsellingvalue,
          frequency: "month",
        };

        const response = await chatConnectionFeeList(values);
        setPaymentDetails(response?.plans || []);
        setLatestPurchasedPlan(response?.latestPurchasedPlan || null);
      } catch (error) {
        console.error("Error fetching plans:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentDetails();
    fetchUserData();
    getinfluencercodedeta();
  }, [counsellingvalue]);

  const getinfluencercodedeta = async () => {
    try {
      const loginUser = localStorage.getItem("currentUser");
      const userDatas = JSON.parse(loginUser);
      const _ids = userDatas?.id || userDatas?._id;
      const value = { user_id: _ids };
      const influencer = await getinfluencercode(value);
      setinfluencercode(influencer);
    } catch (error) {
      console.error("Influencer code error:", error);
    }
  };

  const fetchUserData = async () => {
    try {
      const storedUser = localStorage.getItem("currentUser");
      if (storedUser) {
        const userDatas = JSON.parse(storedUser);
        const _id = userDatas?.id || userDatas?._id;
        const currentUser = await getUserById({ user_id: _id });
        setUservalue(currentUser);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handlePlanPayment = async (plan) => {
    try {
      setSelectedPlan(plan);
      setLoading(true);
      setShowStripeModal(true);
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      const _id = parsedUserData?.id || parsedUserData?._id;

      const value = {
        id: _id,
        name: uservalue?.data?.name,
        email: uservalue?.data?.email,
        amount: plan?.price,
        currency: plan?.currency_name,
        stripe_id: uservalue?.data?.stripe_customer_id || "",
        product_id: plan?.id,
        price_id: plan?.price_id,
        type: "subscription",
        promotion_code:
          influencercode?.data?.influencer?.stripe_promotion_code || "",
        influencer_id: influencercode?.data?.influencer_id || "",
      };

      console.log("Stripe payload:", value);
      const stripeData = await GetStripeData(value);
      console.log("Stripe response:", JSON.stringify(stripeData));
      setClientSecret(stripeData?.paymentIntent);

      // setClientSecret(stripeData?.paymentIntent?.client_secret);
      // if (stripeData?.paymentIntent?.client_secret) {
      //   setClientSecret(stripeData.paymentIntent.client_secret);
      // } else {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Oops!",
      //     text: "Unable to create payment session. Please try again later.",
      //   });
      // }
      if (stripeData?.paymentIntent) {
        // Handle both string and object formats
        const clientSecret =
          typeof stripeData.paymentIntent === "string"
            ? stripeData.paymentIntent
            : stripeData.paymentIntent.client_secret;

        setClientSecret(clientSecret);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops!",
          text: "Unable to create payment session. Please try again later.",
        });
      }
    } catch (err) {
      console.error("Stripe error:", err);
      Swal.fire({
        icon: "error",
        title: "Payment Error",
        text: "Something went wrong while starting payment. Try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-indicator">
        <span className="loader" />
      </div>
    );
  }

  return (
    <div className="monthly-container">
      {paymentDetails.length === 0 ? (
        <p className="no-plans">No plans available.</p>
      ) : (
        paymentDetails.map((apiPlan, idx) => {
          const features = buildFeaturesFromApi(apiPlan);
          const isCurrentPlanActive =
            // latestPurchasedPlan?.subscription_status === "active" &&
            // latestPurchasedPlan?.product_id === apiPlan.id;
            uservalue?.data?.councelling?.id === apiPlan.id;

          return (
            <div
              key={idx}
              className={`monthly-card ${
                isCurrentPlanActive ? "active-border" : ""
              }`}
            >
              <h3 className="card-header">{apiPlan.name}</h3>

              {features.map(([label, value], i) => (
                <div key={i} className="feature-row">
                  <span className="feature-label">{label}</span>
                  <span className="feature-value">
                    {value === true
                      ? "✔"
                      : value === false
                      ? "✖"
                      : typeof value === "string"
                      ? value.charAt(0).toUpperCase() + value.slice(1)
                      : value}
                  </span>
                </div>
              ))}

              <button
                className={`subscribe-button ${
                  isCurrentPlanActive ? "disabled" : ""
                }`}
                onClick={() =>
                  !isCurrentPlanActive && handlePlanPayment(apiPlan)
                }
                disabled={isCurrentPlanActive}
              >
                {isCurrentPlanActive
                  ? "Already Subscribed"
                  : `Subscribe for ${apiPlan.currency_symbol}${apiPlan.price}/${
                      apiPlan.frequency.charAt(0).toUpperCase() +
                      apiPlan.frequency.slice(1)
                    }`}
              </button>
            </div>
          );
        })
      )}

      {/* Stripe Payment Modal */}
      {showStripeModal && clientSecret && selectedPlan && (
        <div className="stripe-modal-overlay">
          <div className="stripe-modal-content">
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <MonthlyCheckoutForm
                clientSecret={clientSecret}
                user={uservalue?.data}
                onPaymentResult={(type, message) => {
                  // Hide Stripe modal immediately
                  setShowStripeModal(false);
                  setClientSecret("");
                  // Then show SweetAlert
                  Swal.fire({
                    icon: type,
                    title:
                      type === "success"
                        ? "Payment Successful"
                        : type === "error"
                        ? "Payment Failed"
                        : "Payment Info",
                    text: message,
                    confirmButtonText: "OK",
                  }).then(() => {
                    if (type === "success") navigate("/Sidebar");
                  });
                }}
              />
            </Elements>

            <button
              className="close-modal-btn"
              onClick={() => setShowStripeModal(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Monthly;
